import { Link } from "react-router-dom";

const Home = () => {
	// Variables
	const Category = ["paan", "chaat", "pizza", "chai", "beverage", "kulfi"];

	// Functions
	const capitalizeFirstLetter = (string) => {
		return string.charAt(0).toUpperCase() + string.slice(1);
	};

	return (
		<div className="container-fluid bg-3 text-center py-1">
			<div className="row">
				{Category.map((value, idx) => (
					<div className="col-12 col-sm-6 col-md-4 col-lg-3" key={idx}>
						<Link to={`/${value}`} className="btn btn-light">
							<img
								src={`https://ik.imagekit.io/manav11goyal11/family-chaat/category/tr:w-600/${value}.jpg`}
								className="img-responsive rounded"
								alt={capitalizeFirstLetter(value)}
							/>
							<p className="text-success m-2 fw-bold">
								{capitalizeFirstLetter(value)}
							</p>
						</Link>
					</div>
				))}
			</div>
		</div>
	);
};

export default Home;
